<template>
  <v-container
    id="shop-table"
    tag="section"
  >
    <base-material-card
      color="indigo"
      icon="mdi-star"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ title }}
        </div>
      </template>
      <v-row>
        <v-col
          cols="12"
          md="12"
        >
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto"
            :label="$t('search')"
            hide-details
            single-line
            style="max-width: 250px;"
          />
        </v-col>
      </v-row>

      <v-divider class="mt-3" />

      <v-data-table
        :headers="localizationHeaders"
        :items="items"
        :search.sync="search"
        :sort-by="['name']"
        :sort-desc="[false]"
        :loading="loading"
      >
        <template v-slot:top>
          <v-toolbar
            flat
          >
            <v-spacer />
            <v-btn
              elevation="1"
              color="primary"
              dark
              fab
              min-width="0"
              small
              @click="addGameRarity"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-toolbar>
        </template>
        <template
          v-slot:[`item.name`]="{ item }"
        >
          <router-link :to="{ name: 'gameRarity', params: { id: item.id }}">
            {{ item.name }}
          </router-link>
        </template>
        <template
          v-slot:[`item.gameRarityGame`]="{ item }"
        >
          <p
            v-for="(game, index) in item.gameRarityGame"
            :key="index"
            style="margin-bottom: 0px;"
          >
            {{ game.gameLine.name }}
          </p>
        </template>
        <template
          v-slot:[`item.actions`]="{ item }"
        >
          <v-btn
            color="success"
            class="px-1 ml-1"
            fab
            x-small
          >
            <v-icon @click="editGameRarity(item.id)">
              mdi-pencil
            </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </base-material-card>

    <base-material-snackbar
      v-model="showErrorMessage"
      type="error"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['vertical']: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import { repositoryFactory } from '@/api/repositoryFactory'
  const gameRaritiesRespository = repositoryFactory.get('gameRarities')

  export default {
    name: 'GameRarityList',
    data: () => ({
      items: [],
      search: undefined,
      loading: false,
      showErrorMessage: false,
      errorMessage: '',
    }),
    computed: {
      title: {
        get () {
          return this.$t('gameRarities')
        },
      },
      localizationHeaders () {
        return [
          {
            text: this.$t('tables.gameRarity.name'),
            value: 'name',
          },
          {
            text: 'Juegos',
            value: 'gameRarityGame',
          },
          {
            sortable: false,
            text: this.$t('actions'),
            value: 'actions',
          },
        ]
      },
    },
    mounted () {
      var self = this
      self.loading = true
      gameRaritiesRespository.get().then(response => {
        if (response.data.isValid) {
          self.items = response.data.data
        } else {
          self.showErrorMessage = true
          self.errorMessage = response.data.errorMessages[0]
        }
        console.log(response)
        self.loading = false
      }).catch(err => {
        self.showErrorMessage = true
        if (err.response.status === 400) {
          self.errorMessage = err.response.data.errorMessages[0]
        } else {
          self.errorMessage = err
        }
        self.loading = false
      })
    },
    methods: {
      addGameRarity () {
        this.$router.push({ name: 'gameRarity', params: { id: 'add' } })
      },
      editGameRarity (id) {
        this.$router.push({ name: 'gameRarity', params: { id: id } })
      },
    },
  }
</script>
